/* eslint-disable no-param-reassign */
import {
  IRaffleAffiliateStatusBadgeDTO,
  IRaffleAffiliateStatusSelectOptionsDTO,
} from "@hooks/dtos/raffles/IRaffleAffiliateDTO";
import { IRaffleDefaultStatusDTO } from "@hooks/dtos/raffles/IRaffleDefaultDTO";
import {
  IRaffleDefaultTicketPurchaseSelectOptionsDTO,
  IRaffleDefaultTicketPurchaseStatusBadgeDTO,
} from "@hooks/dtos/raffles/IRaffleDefaultTicketPurchaseDTO";
import {
  IRaffleSelectOptionsDTO,
  RaffleStatusTypes,
} from "@hooks/dtos/raffles/IRaffleGeneralDTO";
import { RaffleStatusEnum } from "@hooks/enums/raffle";
import {
  RaffleAffiliateStatusEnum,
  RaffleAffiliateStatusTypes,
} from "@hooks/enums/raffle_affiliate";
import {
  RaffleDefaultTicketPurchaseStatusTypes,
  RaffleDefaultTicketPurchaseStatusEnum,
} from "@hooks/enums/raffle_default_ticket_purchase";
import {
  RaffleDefaultDrawScheduleStatusEnum,
  RaffleDefaultDrawScheduleStatusTypes,
  RaffleDefaultDrawScheduleTypeEnum,
  RaffleDefaultDrawScheduleTypes,
} from "@hooks/enums/raffle_default_draw_schedule";
import {
  RaffleDefaultDrawLotteryReasonEnum,
  RaffleDefaultDrawLotteryReasonTypes,
} from "@hooks/enums/raffle_default_draw_lottery";

interface IRaffleDefaultDrawScheduleStatusDTO {
  status: RaffleDefaultDrawScheduleStatusTypes | "";
  text: string;
  title: string;
  color: string;
}

interface IRaffleDefaultDrawLotteryReasonDTO {
  reason: RaffleDefaultDrawLotteryReasonTypes | "";
  text: string;
  title: string;
}

interface IRaffleDefaultDrawScheduleTypeDTO {
  type: RaffleDefaultDrawScheduleTypes | "";
  text: string;
  title: string;
  color: string;
}

export const raffleStatusTypes: IRaffleDefaultStatusDTO[] = [
  {
    status: RaffleStatusEnum.ACTIVE,
    text: "Ativa",
    title: "Esta campanha está ativa.",
    color: "success",
  },
  {
    status: RaffleStatusEnum.INACTIVE,
    text: "Inativa",
    title: "Esta Campanha está inativa.",
    color: "danger",
  },
  {
    status: RaffleStatusEnum.CREATING,
    text: "Criando",
    title: "Esta Campanha está sendo criada.",
    color: "info",
  },
  {
    status: RaffleStatusEnum.PENDING,
    text: "Pendente",
    title: "Esta Campanha está com pendência de pagamento.",
    color: "warning",
  },
  {
    status: RaffleStatusEnum.FINISHED,
    text: "Finalizada",
    title: "Esta Campanha finalizou.",
    color: "primary",
  },
  {
    status: RaffleStatusEnum.EXCLUDED,
    text: "Excluída",
    title: "Esta Campanha foi excluída.",
    color: "danger",
  },
  {
    status: RaffleStatusEnum.QUEUE,
    text: "Fila",
    title: "Esta Campanha está na fila.",
    color: "info",
  },
  {
    status: RaffleStatusEnum.WAITING,
    text: "Aguardando",
    title: "Esta Campanha está aguardando.",
    color: "info",
  },
];

export const getRaffleStatus = (
  status: RaffleStatusTypes,
): IRaffleDefaultStatusDTO => {
  let ret = raffleStatusTypes.find(
    (eventStatusType) => eventStatusType.status === status,
  );
  if (!ret)
    ret = { status: "x", text: "Error", title: "Error", color: "danger" };
  return ret;
};

export const raffleStatusSelect: IRaffleSelectOptionsDTO[] = [
  {
    status: RaffleStatusEnum.ACTIVE,
    text: "Ativa",
    description: "Campanha ativa.",
  },
  {
    status: RaffleStatusEnum.INACTIVE,
    text: "Inativa",
    description: "Campanha inativa.",
  },
  {
    status: RaffleStatusEnum.CREATING,
    text: "Criando",
    description: "Campanha sendo criada.",
  },
  {
    status: RaffleStatusEnum.PENDING,
    text: "Pendente",
    description: "Campanha com pendência de pagamento.",
  },
  {
    status: RaffleStatusEnum.FINISHED,
    text: "Finalizada",
    description: "Esta Campanha finalizou.",
  },
  {
    status: RaffleStatusEnum.EXCLUDED,
    text: "Excluída",
    description: "Campanha excluída.",
  },
  {
    status: RaffleStatusEnum.QUEUE,
    text: "Fila",
    description: "Campanha na fila.",
  },
  {
    status: RaffleStatusEnum.WAITING,
    text: "Aguardando",
    description: "Campanha aguardando.",
  },
];

const raffleDefaultTicketPurchaseStatusBadges: IRaffleDefaultTicketPurchaseStatusBadgeDTO[] =
  [
    {
      status: RaffleDefaultTicketPurchaseStatusEnum.PAID,
      title: "Pago",
      text: "Ticket pago com sucesso",
      color: "success",
    },
    {
      status: RaffleDefaultTicketPurchaseStatusEnum.REFUND,
      title: "Reembolsado",
      text: "Este ticket foi reembolsado",
      color: "warning",
    },
  ];

export const getRaffleDefaultTicketPurchaseStatus = (
  status: RaffleDefaultTicketPurchaseStatusTypes,
): IRaffleDefaultTicketPurchaseStatusBadgeDTO => {
  let ret = raffleDefaultTicketPurchaseStatusBadges.find(
    (raffleDefaultTicketPurchaseStatusBadges) =>
      raffleDefaultTicketPurchaseStatusBadges.status === status,
  );
  if (!ret)
    ret = { status: "", text: "Error", title: "Error", color: "danger" };
  return ret;
};

export const raffleDefaultDrawScheduleStatuses: IRaffleDefaultDrawScheduleStatusDTO[] =
  [
    {
      status: RaffleDefaultDrawScheduleStatusEnum.WAITING,
      text: "Agendado",
      title: "Agendamento criado e aguardando processamento.",
      color: "warning",
    },
    {
      status: RaffleDefaultDrawScheduleStatusEnum.PROCESSING,
      text: "Processando",
      title: "O sorteio está em processamento.",
      color: "info",
    },
    {
      status: RaffleDefaultDrawScheduleStatusEnum.DONE,
      text: "Resultado definido",
      title: "O sorteio foi processado e possui resultado.",
      color: "success",
    },
    {
      status: RaffleDefaultDrawScheduleStatusEnum.FAILED,
      text: "Erro",
      title: "O processamento do sorteio encontrou um erro.",
      color: "danger",
    },
    {
      status: RaffleDefaultDrawScheduleStatusEnum.CANCELED,
      text: "Cancelado",
      title: "O agendamento foi cancelado.",
      color: "secondary",
    },
  ];

export const getRaffleDefaultDrawScheduleStatus = (
  status?: RaffleDefaultDrawScheduleStatusTypes | string,
): IRaffleDefaultDrawScheduleStatusDTO => {
  let ret = raffleDefaultDrawScheduleStatuses.find(
    (scheduleStatus) => scheduleStatus.status === status,
  );

  if (!ret) {
    ret = {
      status: "",
      text: "Não informado",
      title: "Status não informado.",
      color: "secondary",
    };
  }

  return ret;
};

export const raffleDefaultDrawScheduleTypes: IRaffleDefaultDrawScheduleTypeDTO[] =
  [
    {
      type: RaffleDefaultDrawScheduleTypeEnum.LOTTERY,
      text: "Loteria Federal",
      title: "Sorteio baseado no resultado oficial da Loteria Federal.",
      color: "primary",
    },
    {
      type: RaffleDefaultDrawScheduleTypeEnum.RANDOM,
      text: "Sorteio aleatório",
      title: "Sorteio aleatório entre os tickets comprados da campanha.",
      color: "success",
    },
  ];

export const getRaffleDefaultDrawScheduleType = (
  type?: RaffleDefaultDrawScheduleTypes | string,
): IRaffleDefaultDrawScheduleTypeDTO => {
  let ret = raffleDefaultDrawScheduleTypes.find(
    (scheduleType) => scheduleType.type === type,
  );

  if (!ret) {
    ret = {
      type: "",
      text: "Não informado",
      title: "Tipo de agendamento não informado.",
      color: "secondary",
    };
  }

  return ret;
};

export const raffleDefaultDrawLotteryReasons: IRaffleDefaultDrawLotteryReasonDTO[] =
  [
    {
      reason: RaffleDefaultDrawLotteryReasonEnum.LOCAL_RESULT_OUTDATED,
      text: "A base local de resultados da Loteria Federal está desatualizada.",
      title:
        "A fonte local de resultados está antiga e não deve ser usada para agendar automaticamente.",
    },
    {
      reason: RaffleDefaultDrawLotteryReasonEnum.EXTERNAL_API_UNAVAILABLE,
      text: "Não foi possível validar o concurso atual em fonte externa.",
      title:
        "A API externa não respondeu ou não confirmou o concurso atual da Loteria Federal.",
    },
    {
      reason: RaffleDefaultDrawLotteryReasonEnum.LOTTERY_RESULT_UNAVAILABLE,
      text: "Resultado da Loteria Federal indisponível para agendamento.",
      title:
        "Não há concurso confiável disponível para agendar o sorteio pela Loteria Federal.",
    },
  ];

export const getRaffleDefaultDrawLotteryReason = (
  reason?: RaffleDefaultDrawLotteryReasonTypes | string | null,
): IRaffleDefaultDrawLotteryReasonDTO => {
  let ret = raffleDefaultDrawLotteryReasons.find(
    (lotteryReason) => lotteryReason.reason === reason,
  );

  if (!ret) {
    ret = {
      reason: "",
      text: reason || "Aguardando validação da fonte da Loteria Federal.",
      title: "Status da fonte da Loteria Federal ainda não informado.",
    };
  }

  return ret;
};

export const raffleDefaultTicketPurchaseStatusSelect: IRaffleDefaultTicketPurchaseSelectOptionsDTO[] =
  [
    {
      status: RaffleDefaultTicketPurchaseStatusEnum.PAID,
      text: "Pago",
      description: "Para tickets pagos.",
    },
    {
      status: RaffleDefaultTicketPurchaseStatusEnum.REFUND,
      text: "Reembolsado",
      description: "Para tickets reembolsados.",
    },
  ];

export const raffleAffiliateStatusSelect: IRaffleAffiliateStatusSelectOptionsDTO[] =
  [
    {
      status: RaffleAffiliateStatusEnum.ACTIVE,
      text: "Ativo",
      description: "Afiliado ativo e recebendo comissões",
    },
    {
      status: RaffleAffiliateStatusEnum.INACTIVE,
      text: "Inativo",
      description: "Afiliado inativo, não recebe comissões",
    },
    {
      status: RaffleAffiliateStatusEnum.DELETED,
      text: "Excluído",
      description: "Afiliado excluído do sistema",
    },
    {
      status: RaffleAffiliateStatusEnum.OWNER_BLOCK,
      text: "Bloqueado",
      description:
        "Afiliado bloqueado, não receberá mais solicitações deste parceiro",
    },
    {
      status: RaffleAffiliateStatusEnum.OWNER_REQUEST,
      text: "Solicitado pelo Dono",
      description: "Solicitação de afiliação feita pelo dono da rifa",
    },
    {
      status: RaffleAffiliateStatusEnum.OWNER_REJECTED,
      text: "Rejeitado pelo Dono",
      description: "Solicitação de afiliação rejeitada pelo dono da rifa",
    },

    // --- Customer Actions --- //
    {
      status: RaffleAffiliateStatusEnum.CUSTOMER_BLOCK,
      text: "Bloqueada",
      description:
        "Campanha bloqueada, não receberá mais solicitações da mesma.",
    },
    {
      status: RaffleAffiliateStatusEnum.CUSTOMER_REQUEST,
      text: "Solicitado pelo Parceiro",
      description: "Solicitação de afiliação feita pelo parceiro",
    },
    {
      status: RaffleAffiliateStatusEnum.CUSTOMER_REJECTED,
      text: "Rejeitado pelo Parceiro",
      description: "Solicitação de afiliação rejeitada pelo parceiro",
    },
  ];

export const raffleAffiliateStatusOwnerSelect: IRaffleAffiliateStatusSelectOptionsDTO[] =
  [
    {
      status: RaffleAffiliateStatusEnum.ACTIVE,
      text: "Ativo",
      description: "Afiliado ativo e recebendo comissões",
    },
    {
      status: RaffleAffiliateStatusEnum.INACTIVE,
      text: "Inativo",
      description: "Afiliado inativo, não recebe comissões",
    },
    {
      status: RaffleAffiliateStatusEnum.DELETED,
      text: "Excluído",
      description: "Afiliado excluído da campanha",
    },
    {
      status: RaffleAffiliateStatusEnum.OWNER_BLOCK,
      text: "Bloqueado",
      description:
        "Parceiro bloqueado, não recebe mais solicitações deste parceiro",
    },
  ];

const raffleAffiliateStatusBadges: IRaffleAffiliateStatusBadgeDTO[] = [
  // Active status
  {
    status: RaffleAffiliateStatusEnum.ACTIVE,
    title: "Ativo",
    text: "Afiliado ativo e recebendo comissões",
    color: "success",
  },

  // Inactive status
  {
    status: RaffleAffiliateStatusEnum.INACTIVE,
    title: "Inativo",
    text: "Afiliado inativo, não recebe comissões",
    color: "danger",
  },

  // Request status
  {
    status: RaffleAffiliateStatusEnum.CUSTOMER_REQUEST,
    title: "Solicitação do Parceiro",
    text: "Parceiro solicitou afiliação",
    color: "warning",
  },
  {
    status: RaffleAffiliateStatusEnum.OWNER_REQUEST,
    title: "Solicitação do Proprietário",
    text: "Dono(a) da Campanha solicitou afiliação",
    color: "info",
  },

  // Rejection status
  {
    status: RaffleAffiliateStatusEnum.CUSTOMER_REJECTED,
    title: "Rejeitado pelo Parceiro",
    text: "Parceiro rejeitou a afiliação",
    color: "danger",
  },
  {
    status: RaffleAffiliateStatusEnum.OWNER_REJECTED,
    title: "Rejeitado pelo Dono",
    text: "Dono da rifa rejeitou a afiliação",
    color: "danger",
  },

  // Blocked status
  {
    status: RaffleAffiliateStatusEnum.OWNER_BLOCK,
    title: "Bloqueado",
    text: "Parceiro bloqueado pelo proprietário",
    color: "danger",
  },
  {
    status: RaffleAffiliateStatusEnum.CUSTOMER_BLOCK,
    title: "🔒 Bloqueada",
    text: "Parceiro bloqueou esta Campanha",
    color: "danger",
  },

  // Deleted status
  {
    status: RaffleAffiliateStatusEnum.DELETED,
    title: "Excluído",
    text: "Afiliado removido do sistema",
    color: "dark",
  },
];

export const getRaffleAffiliateStatus = (
  status: RaffleAffiliateStatusTypes,
): IRaffleAffiliateStatusBadgeDTO => {
  let ret = raffleAffiliateStatusBadges.find(
    (raffleAffiliateStatusBadges) =>
      raffleAffiliateStatusBadges.status === status,
  );
  if (!ret)
    ret = { status: "", text: "Error", title: "Error", color: "danger" };
  return ret;
};
